// extracted by mini-css-extract-plugin
export default {"container":"dropdown_container__bDcmO","clicked":"dropdown_clicked__p7v5p","fakecontainer":"dropdown_fakecontainer__olwg+","subcontainer":"dropdown_subcontainer__z7h-h"};